import { addSlashes, EMPTY_IMAGE } from 'utils/cms/utils';
import { OVERRIDE } from 'utils/dynamicData';

function parseVideoLink(link) {
	if (!link) return null;

	const youtubeIdMatch = link.match(/(?:youtube(?:-nocookie)?\.com\/(?:watch.*[?&]v=|(?:v|embed|watch|shorts|live|e)\/)|youtu\.be\/)([0-9a-z_-]+)(?:[?&#]|$)/i);
	const youtubeId = youtubeIdMatch?.[1] || null;

	const youtubePlaylistMatch = link.match(/(?:youtube(?:-nocookie)?\.com\/|youtu\.be\/).*[?&]list=([0-9a-zA-Z_-]+)(?:[?&#]|$)/i);
	const youtubePlaylist = youtubePlaylistMatch?.[1] || null;

	if (youtubeId || youtubePlaylist) {
		return {
			thumbSrc: youtubeId ? `https://img.youtube.com/vi/${youtubeId}/mqdefault.jpg` : EMPTY_IMAGE,
			youtubeId: youtubeId,
			youtubePlaylistId: youtubePlaylist,
		};
	}

	// Vimeo patterns
	const vimeoPattern = /vimeo\.com\/(\d+)/;
	const vimeoMatch = link.match(vimeoPattern);
	if (vimeoMatch) {
		return {
			thumbSrc: EMPTY_IMAGE,
			vimeoId: vimeoMatch[1]
		};
	}

	return {};
}

function mapCmsVideosToBoltVideos(cmsData) {
	const videosList = cmsData?.trailers;
	if (!videosList) return {};

	// Then, map over the CMS videos, overriding existing keys and adding new ones
	return Object.entries(videosList).reduce((acc, [key, item]) => {
		acc[key] = {
			name: item.title || item.defaultTitle,
			order: item.order,
			thumbAria: item.thumbnailAlt || item.defaultTitle,
			...parseVideoLink(item.url),
		};
		return acc;
	}, { [OVERRIDE]: true });
}

export default function mapVideos(cmsData, appData) {
	if (!appData?.pages?.boltVideos) return null;

	const videosData = cmsData?.pages?.videos;
	if (!videosData?.active) return null;

	return {
		disabled: false,
		data: {
			list: mapCmsVideosToBoltVideos(cmsData),
		},
		name: videosData.name,
		order: cmsData.pages.home?.sections?.videos?.order ?? videosData.order,
		path: addSlashes(videosData.path),
	};
}